<template>
    <ValidationProvider
        :vid="'vp' + name"
        :ref="name || label"
        tag="div"
        :rules="rules"
        :name="name || label"
        v-slot="{ errors, required, classes }"
        class="form-floating"
    >
        <v-select
            :name="name"
            :id="name"
            v-model="innerValue"
            :clearable="is_clearable"
            :disabled="is_disabled"
            :class="{ editable: true, 'selected-form-select': innerValue.length !== 0}"
            :options="select_options"
            :multiple="is_multiple"
            :label="label_select"
            :reduce="reduce"
            class="form-select"
            @input="fn_onchange"
        >
            <span slot="no-options">Oups, aucun résultat trouvé !</span>
        </v-select>

        <label :for="name">
            <slot v-if="!label"></slot>
            <span class="label-select" v-else>{{ label }}</span>

            <span class="text-danger">{{ required ? " *" : "" }}</span>
        </label>

        <span v-if="tick_buttons">
            <button v-if="innerValue.length < select_options.length" type="button" @click="tick_all">
                Tout sélectionner
            </button>
            <button v-else-if="innerValue.length === select_options.length" type="button" @click="untick_all">
                Tout désélectionner
            </button>
        </span>

        <input style="display: none" class="form-control" :class="classes"/>
        <span v-if="display_error" class="invalid-feedback">{{ errors[0] }}</span>
    </ValidationProvider>
</template>

<script>
import vSelect from "vue-select";

export default {
    name: "ValidationSelect",
    components: {
        vSelect,
    },
    props: {
        name: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        label_select: {
            type: String,
            default: "title",
        },
        rules: {
            type: [Object, String],
            default: "",
        },
        value: {
            type: null,
            default: "",
        },
        fn_onchange: {
            type: Function,
            default: () => {},
        },
        select_options: {
            type: Array,
            default: () => [],
        },
        is_disabled: {
            type: Boolean,
            default: false,
        },
        is_clearable: {
            type: Boolean,
            default: true,
        },
        is_multiple: {
            type: Boolean,
            default: true,
        },
        display_error: {
            type: Boolean,
            default: true,
        },
        reduce: {
            type: Function,
            default: title => title.id
        },
        tick_buttons: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        innerValue: "",
    }),
    watch: {
        innerValue(value) {
            this.$emit("input", value);
        },
        value(val) {
            if (val !== this.innerValue) {
                this.innerValue = val;
            }
        },
    },
    mounted() {
        if (this.value) {
            this.innerValue = this.value;
        }
    },
    methods: {
        tick_all() {
            this.innerValue = this.select_options.map(t => t.id);
        },
        untick_all() {
            this.innerValue = [];
        }
    }
};
</script>
